import { configureStore } from "@reduxjs/toolkit";
import backOrderSlice from "./backOrderSlice";
import diSlice from "./diSlice";
import forecastSlice from "./forecastSlice";
import boTrendSlice from "./boTrendSlice";
import boWarehouseSlice from "./boWarehouse";
import userSlice from "./userSlice";
import boPartsSlice from "./boPartsSlice";
import vpuSlice from "./vpuSlice";
import cartonSummarySlice from "./cartonSummarySlice";
import dealerTop50Slice from "./dealerTop50Slice";
import modelWiseSlice from "./modelWiseSlice";
import poPendingSlice from "./poPendingSlice";
import KDStockSlice from "./KDStockSlice";
import aoboSlice from "./aoboSlice";
import manualFileUploadSlice from "./manualFileUploadSlice";
import customHomeScreenSlice from "./customHomeScreenSlice";

export default configureStore({
  reducer: {
    backorder: backOrderSlice,
    di: diSlice,
    forecast: forecastSlice,
    boTrend: boTrendSlice,
    boWarehouse: boWarehouseSlice,
    user: userSlice,
    boParts: boPartsSlice,
    vpu: vpuSlice,
    cartonSummary: cartonSummarySlice,
    dealerTop50: dealerTop50Slice,
    modelWise: modelWiseSlice,
    po: poPendingSlice,
    kdStock: KDStockSlice,
    aobo: aoboSlice,
    manualFileUpload: manualFileUploadSlice,
    customHomeScreen: customHomeScreenSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
